/* eslint-disable */
/* tslint:disable */
// @ts-nocheck
/*
 * ---------------------------------------------------------------
 * ## THIS FILE WAS GENERATED VIA SWAGGER-TYPESCRIPT-API        ##
 * ##                                                           ##
 * ## AUTHOR: acacode                                           ##
 * ## SOURCE: https://github.com/acacode/swagger-typescript-api ##
 * ---------------------------------------------------------------
 */

import {
  AccessLockDTO,
  CompanyDTO,
  CompanyOptionDTO,
  CompanyRelationshipDto,
  CompanyRelationshipFilterDto,
  CompanyRelationshipResponseDto,
  CompanyRelationshipStatus,
  CompanySearchParamsDTO,
  CompanyStatisticsDTO,
  CompanyTerminationDTO,
  ErrorResponse,
  LinkGenerationResponse,
  MailHistoryDTO,
  Pageable,
  QuoteTerminationParamsDTO,
  SearchResultCompanyOverviewRowDTO,
} from "./data-contracts";
import { ContentType, HttpClient, RequestParams } from "./http-client";

export class CompanyApi<
  SecurityDataType = unknown,
> extends HttpClient<SecurityDataType> {
  /**
   * @description Only back-office employees can approve registration requests. When a company is approved, its status changes to 'CONFIRMED' and the first employee (CEO) is activated.
   *
   * @tags company-api
   * @name ApproveRegistration
   * @summary Approve a company registration request
   * @request POST:/api/company/approve/{companyId}
   * @secure
   */
  approveRegistration = (companyId: number, params: RequestParams = {}) =>
    this.request<CompanyDTO, ErrorResponse | CompanyDTO>({
      path: `/api/company/approve/${companyId}`,
      method: "POST",
      secure: true,
      ...params,
    });
  /**
   * @description Archives a company that is in status TERMINATED or REJECTED. Performs immediate anonymization (bypassing DEADLINE_15 deadline with a warning log), pre-cleanup of tokens/memberships/tenant, and preserves users with active membership in another company. Only back-office employees with operator role can archive companies.
   *
   * @tags company-api
   * @name ArchiveCompany
   * @summary Archive a company
   * @request POST:/api/company/archive/{companyId}
   * @secure
   */
  archiveCompany = (companyId: number, params: RequestParams = {}) =>
    this.request<CompanyDTO, ErrorResponse | CompanyDTO>({
      path: `/api/company/archive/${companyId}`,
      method: "POST",
      secure: true,
      ...params,
    });
  /**
   * @description Only back-office employees can cancel the termination of companies.
   *
   * @tags company-api
   * @name CancelTerminationCompany
   * @summary Cancel a termination of a company
   * @request POST:/api/company/cancel-termination/{companyId}
   * @secure
   */
  cancelTerminationCompany = (companyId: number, params: RequestParams = {}) =>
    this.request<CompanyDTO, ErrorResponse | CompanyDTO>({
      path: `/api/company/cancel-termination/${companyId}`,
      method: "POST",
      secure: true,
      ...params,
    });
  /**
   * @description Deletes the company and all associated users, tokens, and related data. Only accessible by users with OPERATOR role.
   *
   * @tags company-api
   * @name DeleteCompany
   * @summary Delete a company with all related data
   * @request DELETE:/api/company/{id}
   * @secure
   */
  deleteCompany = (id: number, params: RequestParams = {}) =>
    this.request<void, ErrorResponse | void>({
      path: `/api/company/${id}`,
      method: "DELETE",
      secure: true,
      ...params,
    });
  /**
   * @description Generates a new signup link for a company that is in INVITED status. All previous signup tokens for this company are invalidated. No email is sent — the link is returned in the response for the operator to share manually. Only accessible by operators.
   *
   * @tags company-api
   * @name GenerateSignupLink
   * @summary Generate a company signup link
   * @request POST:/api/company/{id}/generate-signup-link
   * @secure
   */
  generateSignupLink = (id: number, params: RequestParams = {}) =>
    this.request<
      LinkGenerationResponse,
      ErrorResponse | LinkGenerationResponse
    >({
      path: `/api/company/${id}/generate-signup-link`,
      method: "POST",
      secure: true,
      ...params,
    });
  /**
   * @description Returns a paginated list of all companies with their relationship status to the specified company. Visible only to authorized users. Relationships include whitelist/blacklist status and other relevant information. Filtering is supported via request body (company name, relationship status, country).
   *
   * @tags company-api
   * @name GetAllRelationship
   * @summary List all relationships of a company
   * @request POST:/api/company/{sourceCompanyId}/all-relationships
   * @secure
   */
  getAllRelationship = (
    sourceCompanyId: number,
    query: {
      pageable: Pageable;
    },
    data: CompanyRelationshipFilterDto,
    params: RequestParams = {},
  ) =>
    this.request<
      CompanyRelationshipResponseDto,
      ErrorResponse | CompanyRelationshipResponseDto
    >({
      path: `/api/company/${sourceCompanyId}/all-relationships`,
      method: "POST",
      query: query,
      body: data,
      secure: true,
      type: ContentType.Json,
      ...params,
    });
  /**
   * No description
   *
   * @tags company-api
   * @name GetCompany
   * @summary Get company by ID
   * @request GET:/api/company/{id}
   * @secure
   */
  getCompany = (id: number, params: RequestParams = {}) =>
    this.request<CompanyDTO, ErrorResponse | CompanyDTO>({
      path: `/api/company/${id}`,
      method: "GET",
      secure: true,
      ...params,
    });
  /**
   * @description Returns the email history for the company of the currently authenticated user. Available to all authenticated users (operators and customers).
   *
   * @tags company-api
   * @name GetCompanyEMailHistory
   * @summary Get email history for current user's company
   * @request GET:/api/company/email-history
   * @secure
   */
  getCompanyEMailHistory = (params: RequestParams = {}) =>
    this.request<MailHistoryDTO, ErrorResponse>({
      path: `/api/company/email-history`,
      method: "GET",
      secure: true,
      ...params,
    });
  /**
   * @description Returns every company's id and name, sorted ascending by name — a slim projection for selection lists (e.g. the company filter on the internal request overview). Restricted to back-office roles; unlike `POST /api/company/search` this endpoint carries neither the aggregated business KPIs nor the last-login user name and timestamp of a company's employee.
   *
   * @tags company-api
   * @name GetCompanyOptions
   * @summary List companies as selection options
   * @request GET:/api/company/options
   * @secure
   */
  getCompanyOptions = (params: RequestParams = {}) =>
    this.request<CompanyOptionDTO[], ErrorResponse>({
      path: `/api/company/options`,
      method: "GET",
      secure: true,
      ...params,
    });
  /**
   * @description Get statistics for a company including user counts, request counts, and quote counts. Only operators can view statistics for other companies. Returns null (empty response) if the user is not authorized.
   *
   * @tags company-api
   * @name GetCompanyStatistics
   * @summary Get company statistics
   * @request GET:/api/company/statistics/{id}
   * @secure
   */
  getCompanyStatistics = (id: number, params: RequestParams = {}) =>
    this.request<CompanyStatisticsDTO, ErrorResponse | CompanyStatisticsDTO>({
      path: `/api/company/statistics/${id}`,
      method: "GET",
      secure: true,
      ...params,
    });
  /**
   * @description Returns the current business relationship status between two active BoxHub member companies. Managing directors can view whether their company and another member company are whitelisted (allowed) or blacklisted (blocked). Business rules: Only if both companies have whitelisted each other, requests and offers are visible and notified by email. A blacklist on either side hides all new requests and offers for both companies, but does not cancel ongoing or accepted offers. Status changes from whitelist to blacklist are only effective every 14 days for stability, but can be changed at any time by the managing director. Default: new company relationships are treated as whitelisted until actively changed.
   *
   * @tags company-api
   * @name GetRelationship
   * @summary Get the relationship status between two companies (Whitelist/Blacklist)
   * @request GET:/api/company/{sourceCompanyId}/relationships/{targetCompanyId}
   * @secure
   */
  getRelationship = (
    sourceCompanyId: number,
    targetCompanyId: number,
    params: RequestParams = {},
  ) =>
    this.request<
      CompanyRelationshipDto,
      ErrorResponse | CompanyRelationshipDto
    >({
      path: `/api/company/${sourceCompanyId}/relationships/${targetCompanyId}`,
      method: "GET",
      secure: true,
      ...params,
    });
  /**
   * @description Prepares company termination with date set according to termination rules
   *
   * @tags company-api
   * @name InitiateCompanyTermination
   * @summary Initiate company termination
   * @request POST:/api/company/terminate/init/{companyId}
   * @secure
   */
  initiateCompanyTermination = (
    companyId: number,
    params: RequestParams = {},
  ) =>
    this.request<CompanyTerminationDTO, ErrorResponse | CompanyTerminationDTO>({
      path: `/api/company/terminate/init/${companyId}`,
      method: "POST",
      secure: true,
      ...params,
    });
  /**
   * @description Only back-office employees can lock companies. Firma sperren als Innendienstler
   *
   * @tags company-api
   * @name LockCompany
   * @summary Lock a company
   * @request POST:/api/company/lock/{companyId}
   * @secure
   */
  lockCompany = (
    companyId: number,
    data: AccessLockDTO,
    params: RequestParams = {},
  ) =>
    this.request<AccessLockDTO, ErrorResponse | AccessLockDTO>({
      path: `/api/company/lock/${companyId}`,
      method: "POST",
      body: data,
      secure: true,
      type: ContentType.Json,
      ...params,
    });
  /**
   * @description Only back-office employees can activate companies.
   *
   * @tags company-api
   * @name ReactivateCompany
   * @summary Reactivate a company
   * @request POST:/api/company/reactivate/{companyId}
   * @secure
   */
  reactivateCompany = (companyId: number, params: RequestParams = {}) =>
    this.request<CompanyDTO, ErrorResponse | CompanyDTO>({
      path: `/api/company/reactivate/${companyId}`,
      method: "POST",
      secure: true,
      ...params,
    });
  /**
   * @description Only back-office employees can reject registration requests. When a company is rejected, its status changes to 'REJECTED' and the first employee (CEO) is deactivated.
   *
   * @tags company-api
   * @name RejectRegistration
   * @summary Reject a company registration request
   * @request POST:/api/company/reject/{companyId}
   * @secure
   */
  rejectRegistration = (companyId: number, params: RequestParams = {}) =>
    this.request<CompanyDTO, ErrorResponse | CompanyDTO>({
      path: `/api/company/reject/${companyId}`,
      method: "POST",
      secure: true,
      ...params,
    });
  /**
   * @description Allows an operator to resend the invitation email. For security reasons, all previous tokens for company users are deleted and a new signup token is generated and sent via email.
   *
   * @tags company-api
   * @name ResendCompanyInvitation
   * @summary Resend a company invitation email
   * @request POST:/api/company/resend-invitation/{companyId}
   * @secure
   */
  resendCompanyInvitation = (companyId: number, params: RequestParams = {}) =>
    this.request<string, ErrorResponse | string>({
      path: `/api/company/resend-invitation/${companyId}`,
      method: "POST",
      secure: true,
      ...params,
    });
  /**
   * @description Update company information. Operators can update any company. Regular users can only update their own company.
   *
   * @tags company-api
   * @name SaveCompany
   * @summary Update company
   * @request PUT:/api/company/{id}
   * @secure
   */
  saveCompany = (id: number, data: CompanyDTO, params: RequestParams = {}) =>
    this.request<CompanyDTO, ErrorResponse | CompanyDTO>({
      path: `/api/company/${id}`,
      method: "PUT",
      body: data,
      secure: true,
      type: ContentType.Json,
      ...params,
    });
  /**
   * @description Backs the internal BoxHub company overview screen used by the back-office staff. Returns a paged list of registered companies that match the given filters (company name substring and/or company status) together with aggregated business KPIs per company: the assigned tenant (group) name, the timestamp and user name of the last login of any of the company's employees, the number of published requests including the subset that led to a confirmed order, and the number of submitted quotes (latest version per request and bidder) including the subset that was accepted. Restricted to back-office roles (ADMIN, OPERATOR_MANAGING_DIRECTOR, OPERATOR) — not intended for client-side users.
   *
   * @tags company-api
   * @name SearchCompanies
   * @summary Search companies (internal company overview)
   * @request POST:/api/company/search
   * @secure
   */
  searchCompanies = (
    data: CompanySearchParamsDTO,
    params: RequestParams = {},
  ) =>
    this.request<SearchResultCompanyOverviewRowDTO, ErrorResponse>({
      path: `/api/company/search`,
      method: "POST",
      body: data,
      secure: true,
      type: ContentType.Json,
      ...params,
    });
  /**
   * @description Allows the managing director of an active BoxHub member company to define business relationships with other active member companies. You can whitelist (allow) or blacklist (block) another company. Only if both companies have whitelisted each other, requests and offers become visible and are notified by email. A blacklist on either side hides all new requests and offers for both companies, but does not cancel ongoing or accepted offers. Status changes from whitelist to blacklist are only effective every 14 days for stability, but can be changed at any time by the managing director. All business rules and notification requirements are enforced as described in the user story.
   *
   * @tags company-api
   * @name SetRelationship
   * @summary Set the relationship status between two companies (Whitelist/Blacklist)
   * @request PUT:/api/company/{sourceCompanyId}/relationships/{targetCompanyId}
   * @secure
   */
  setRelationship = (
    sourceCompanyId: number,
    targetCompanyId: number,
    data: CompanyRelationshipStatus,
    params: RequestParams = {},
  ) =>
    this.request<
      CompanyRelationshipDto,
      ErrorResponse | CompanyRelationshipDto
    >({
      path: `/api/company/${sourceCompanyId}/relationships/${targetCompanyId}`,
      method: "PUT",
      body: data,
      secure: true,
      type: ContentType.Json,
      ...params,
    });
  /**
   * @description Only back-office employees can terminate companies.
   *
   * @tags company-api
   * @name TerminateCompany
   * @summary Terminate a company
   * @request POST:/api/company/terminate/{companyId}
   * @secure
   */
  terminateCompany = (
    companyId: number,
    data: CompanyTerminationDTO,
    params: RequestParams = {},
  ) =>
    this.request<CompanyTerminationDTO, ErrorResponse | CompanyTerminationDTO>({
      path: `/api/company/terminate/${companyId}`,
      method: "POST",
      body: data,
      secure: true,
      type: ContentType.Json,
      ...params,
    });
  /**
   * @description Only back-office employees can unlock companies.
   *
   * @tags company-api
   * @name UnlockCompany
   * @summary Unlock a company
   * @request POST:/api/company/unlock/{companyId}
   * @secure
   */
  unlockCompany = (companyId: number, params: RequestParams = {}) =>
    this.request<CompanyDTO, ErrorResponse | CompanyDTO>({
      path: `/api/company/unlock/${companyId}`,
      method: "POST",
      secure: true,
      ...params,
    });
  /**
   * @description Validates if a termination date is within the allowed range. Returns validation errors if the date is invalid. Restricted to operators (paired with the operator-only termination endpoints).
   *
   * @tags company-api
   * @name ValidateTerminateDates
   * @summary Validate termination date
   * @request POST:/api/company/validate-termination-date
   * @secure
   */
  validateTerminateDates = (
    data: QuoteTerminationParamsDTO,
    params: RequestParams = {},
  ) =>
    this.request<ErrorResponse, ErrorResponse>({
      path: `/api/company/validate-termination-date`,
      method: "POST",
      body: data,
      secure: true,
      type: ContentType.Json,
      ...params,
    });
}
